import { onBeforeUnmount, ref } from "vue";

export function useOrderTimer({ onExpired } = {}) {
  const timerValue = ref("00:00");
  const timerVisible = ref(false);
  const timerWarning = ref(false);

  let intervalId = null;

  function clear() {
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
  }

  function hide() {
    clear();
    timerVisible.value = false;
  }

  function start(expiredAt) {
    clear();

    const now = new Date();
    const expiry = new Date(expiredAt);
    let timeLeft = Math.floor((expiry - now) / 1000);

    if (Number.isNaN(timeLeft) || timeLeft <= 0) {
      timerValue.value = "00:00";
      onExpired?.();
      return;
    }

    timerVisible.value = true;

    const tick = () => {
      const minutes = Math.floor(timeLeft / 60);
      const seconds = timeLeft % 60;

      timerValue.value = `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
      timerWarning.value = timeLeft <= 60;

      if (timeLeft <= 0) {
        timerValue.value = "00:00";
        clear();
        onExpired?.();
        return;
      }

      timeLeft -= 1;
    };

    tick();
    intervalId = window.setInterval(tick, 1000);
  }

  onBeforeUnmount(clear);

  return {
    timerValue,
    timerVisible,
    timerWarning,
    startTimer: start,
    clearTimer: clear,
    hideTimer: hide,
  };
}
